import {IUserServicesState} from '../state/user-services.state';
import {SETTINGS_SERVICES_ACTION, SettingsServicesAction} from '../action/user-services.action';

export const initialSettingsServicesState: IUserServicesState = {
  logos: [],
  CUSTOM_BRANDING: {
    custom_logo_image_link: '',
    custom_logo_image_path: '',
    expires_at: '',
    id: 0,
    is_enabled: false,
    is_renewable: false,
    is_trial: false,
    trial_applicable: false,
    user_service_id: 0,
  },
  LIVE_TRANSLATIONS: {
    auto_renew_on_quota_exceeded: false,
    auto_translation: false,
    pricing_tier: '',
    id: 0,
    is_enabled: false,
    is_renewable: false,
    is_trial: false,
    trial_applicable: false,
    user_service_id: 0,
  },
  MODIFY_MENU: {
    color_mode: '',
    expires_at: '',
    features_pattern: '',
    id: 0,
    is_enabled: false,
    is_renewable: false,
    is_trial: false,
    trial_applicable: false,
    user_service_id: 0,
  },
  REMEDIATION: {
    expires_at: '',
    fixes_headers_file_path: '',
    fixes_img_alt_file_path: '',
    fixes_social_sensitivity_file_path: null,
    fixes_vague_links_file_path: null,
    id: 0,
    img_ai_processed_number: 0,
    is_enabled: false,
    is_renewable: false,
    is_trial: false,
    numbers: undefined,
    trial_applicable: false,
    user_service_id: 0,
  },
  USAGE_STATS: {
    NINETY: undefined,
    SEVEN: undefined,
    SIXTY: undefined,
    THIRTY: undefined,
    expires_at: '',
    id: 0,
    is_enabled: false,
    is_renewable: false,
    is_trial: false,
    trial_applicable: false,
    user_service_id: 0,
  },
  VISIBLE: false,
  WHITE_LABEL: {
    expires_at: '',
    hide_asterisk: false,
    hide_donate: false,
    hide_logo: false,
    hide_manage: false,
    hide_report: false,
    id: 0,
    is_enabled: false,
    is_renewable: false,
    is_trial: false,
    trial_applicable: false,
    user_service_id: 0,
  },
  domains: [],
};

export function settingServicesReducer(
  state: IUserServicesState = initialSettingsServicesState,
  action: SettingsServicesAction,
): IUserServicesState {
  switch (action.type) {
    case SETTINGS_SERVICES_ACTION.INIT_SETTINGS_SERVICES:
      return {
        ...state,
        ...action.payload,
      };
    case SETTINGS_SERVICES_ACTION.RESET_SETTINGS_SERVICES:
      return initialSettingsServicesState;
    default:
      return state;
  }
}
